import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

export interface CbcrAccountOption {
  ACCT_KEY?: string | number | null;
  ACCT?: string;
  [key: string]: unknown;
}

export interface SaveAcctTaggingResponse {
  callSuccess: string;
  errorMessage?: string;
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class CbcEditAcctTaggingService {
  constructor(private http: HttpClient) {}

  private mergeParams(
    globalService: any,
    filterParams: any,
    explicitParams: Record<string, string | number | null | undefined>
  ): HttpParams {
    const merged: Record<string, string> = {};
    const g = globalService || {};
    const f = filterParams || {};
    Object.keys(g).forEach((k) => {
      if (g[k] != null && g[k] !== '') merged[k] = String(g[k]);
    });
    Object.keys(f).forEach((k) => {
      if (f[k] != null && f[k] !== '') merged[k] = String(f[k]);
    });
    Object.keys(explicitParams).forEach((k) => {
      const v = explicitParams[k];
      if (v != null && v !== '') merged[k] = String(v);
    });
    let p = new HttpParams();
    Object.keys(merged).forEach((k) => { p = p.set(k, merged[k]); });
    return p;
  }

  loadAccounts(
    baseUrl: string,
    ssoId: string,
    systemAcctKey: string | number | null | undefined,
    cbcrAcctKey: string | number | null | undefined,
    globalService: any = {},
    filterParams: any = {}
  ): Observable<CbcrAccountOption[]> {
    const url = `${baseUrl}/loadJsonObject`;
    const params = this.mergeParams(globalService, filterParams, {
      action_code: 'a309q2',
      sso_id: ssoId,
      system_acct_key: systemAcctKey ?? '',
      cbcr_acct_key: cbcrAcctKey ?? '',
    });
    return this.http
      .get<{ callSuccess: string; jsonObject?: CbcrAccountOption[]; errorMessage?: string }>(url, { params })
      .pipe(
        map((res) => {
          if (res.callSuccess === '1' && res.jsonObject) return res.jsonObject;
          throw new Error(res.errorMessage || 'Failed to load accounts');
        })
      );
  }

  saveAcctTagging(
    baseUrl: string,
    clobData: any[],
    clobSettings: any[],
    ssoId: string,
    globalService: any,
    filterParams: any
  ): Observable<SaveAcctTaggingResponse> {
    const url = `${baseUrl}/saveJsonObject?action_code=b6w9y1`;
    let params = this.mergeParams(globalService, filterParams, { sso_id: ssoId });
    params = params.set('clob_data', JSON.stringify(clobData));
    params = params.set('clob_settings', JSON.stringify(clobSettings));
    const body = params.toString();
    return this.http.post<SaveAcctTaggingResponse>(url, body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true,
    });
  }
}
